const isPurchaseWithNoItems = (orderDetails) => {
    if (!orderDetails.items || orderDetails.items.length === 0) {
        return true;
    } else {
        return false;
    }
};

const isOneTimePayment = (orderDetails) => {
    // TODO: potwierdzić czy zawsze płatności jednorazowe (np. VASy)
    const multiplePaymentTypes = ['ABONAMENT', 'RATY'];
    if (
        multiplePaymentTypes.some((mpt) =>
            orderDetails.items[0].eci_payment_type.toUpperCase().match(new RegExp(mpt))
        )
    ) {
        return false;
    }
    return true;
};

const isListedProductsPurchased = (orderDetails) => {
    const ignoredProductCodes = [
        'XP_7291', // Zabezpiecz PESEL
        'XP_7300', // Pakiet bezpieczeństwa
        'XP_7303', // Zabezpiecz PESEL - pakiet
        'XP_7313', // Zabezpiecz PESEL dla Firm
        'XP_7810', // Ochrona Smartfona
        'XP_7811', // Ochrona Smartfona Premium
        'XP_7812', // Ochrona Smartfona Premium (24)
        'XP_7813', // Ochrona Smartfonów
        'XP_7814', // Ochrona Smartfona F
        'XP_7815' // Ochrona Smartfona Premium F
    ];
    const ignoredProductNames = [
        'ZABEZPIECZ PESEL',
        'PAKIET BEZPIECZEŃSTWA',
        'ZABEZPIECZ PESEL - PAKIET',
        'ZABEZPIECZ PESEL DLA FIRM',
        'OCHRONA SMARTFONA',
        'OCHRONA SMARTFONA PREMIUM',
        'OCHRONA SMARTFONA PREMIUM (24)',
        'OCHRONA SMARTFONÓW',
        'OCHRONA SMARTFONA F',
        'OCHRONA SMARTFONA PREMIUM F',
        'INTERNET MOBILNY DLA DOMU'
    ];

    let isIgnoredProductFound = false;
    orderDetails.items.forEach((i) => {
        if (!isIgnoredProductFound) {
            if (ignoredProductCodes.some((pc) => i.item_id.toUpperCase().match(pc))) {
                isIgnoredProductFound = true;
            }
            if (ignoredProductNames.some((pn) => i.item_name.toUpperCase().match(pn))) {
                isIgnoredProductFound = true;
            }
        }
    });

    return isIgnoredProductFound;
};

export { isPurchaseWithNoItems, isOneTimePayment, isListedProductsPurchased };
